var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParkingSpaces({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13211_25156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.7207 0.51001V23.49",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7207 0.51001V23.49",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7207 0.51001V23.49",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7109 0.51001V23.49",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7091 12H1.28906",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13211_25156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingSpaces);
export default __webpack_public_path__ + "static/media/parking-spaces.86f6f111.svg";
export { ForwardRef as ReactComponent };